export const WHATSAPP_NUMBER = '5575981872440';

const wa = (msg) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(msg)}`;

export const WHATSAPP_URL        = wa('Olá, vim do site e gostaria de agendar uma consulta com dr. Mateus');
export const WHATSAPP_URL_CONV   = wa('Olá, vim do site e gostaria de saber se dr. Mateus atende o meu convênio');
export const WHATSAPP_URL_PROC   = wa('Olá, vim do site e gostaria de saber mais sobre a Simpatectomia');
export const INSTAGRAM_URL       = 'https://instagram.com/drmateus_cirtorax';
export const DOCTOR_PHOTO_HERO = '/images/doctor_hero_v3.png';
export const DOCTOR_PHOTO_ABOUT = 'https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/wizdtib6_AMO%20178.JPG';
export const LOGO_WITH_NAME = 'https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/b62omgvs_Logotipo%20%2B%20nome.PNG';
export const LOGO_ONLY = 'https://customer-assets.emergentagent.com/job_simpatectomia-feira/artifacts/ujw9x9g6_Logotipo.PNG';
export const LOGO_NODULO_FULL = '/images/logo_nodulo_completo.png';
